<!-- 由 suu 创建于 2022-09-02 星期五 -->
<template>
  <div>
    <div class="end-camp-list" v-if="list && list.length">
      <div class="sl-item" v-for="(item, index) in list" :key="index">
        <div class="i-left">
          <div class="l-title">{{ item.truename }}的结营总结</div>
          <div class="l-date"
            >生成时间：{{
              item.updatetime.split(' ')[0].replace(/-/g, '.')
            }}</div
          >
          <div class="c-name">创建人：{{ item.c_name }}</div>
        </div>
        <div class="i-btn user-btn" @click="handleClick(item)">查看</div>
        <div class="i-flag" v-if="cid">
          <div class="flag-1" v-if="item.flag == 1">已保存未发布</div>
          <img
            class="flag-2"
            v-if="item.flag == 2"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/wksum-icon-yfb"
            alt=""
          />
        </div>
      </div>
    </div>
    <van-empty description="暂无" v-else />
    <div class="c-btn" @click="bandleCreate" v-if="cid"
      ><span class="iconfont icon-jiahao"></span><span>创建新总结</span></div
    >
  </div>
</template>

<script>
export default {
  name: 'end-camp-list',

  components: {},

  props: {},

  data() {
    return {
      // 75135
      uid: this.$route.query.uid,
      cid: this.$route.query.cid,
      pid: this.$route.query.pid,
      list: [],
      urlObj: {
        pro: 'https://btvue.gymcity.com.cn/endCampCer',
        test: 'https://tbtvue.gymcity.com.cn/endCampCer',
        dev: 'https://tbtvue.gymcity.com.cn/endCampCer'
      }
    }
  },

  computed: {},

  watch: {},

  created() {
    this.getList()
  },

  mounted() {},

  destroyed() {},

  methods: {
    bandleCreate() {
      let url = this.urlObj[this.$http.curEv()]
      location.href =
        url +
        '?uid=' +
        this.uid +
        '&cid=' +
        this.cid +
        '&pid=' +
        this.pid +
        '&token=' +
        localStorage.getItem('token')
    },
    handleClick(item) {
      let url = this.urlObj[this.$http.curEv()]
      location.href =
        url +
        '?uid=' +
        this.uid +
        '&cid=' +
        this.cid +
        '&pid=' +
        this.pid +
        '&rid=' +
        item.id +
        '&token=' +
        localStorage.getItem('token')
    },
    getList() {
      let url = 'member/AppCamp/getSummaryList'
      if (this.cid) {
        url = 'member/AppCampCoach/getSummaryList'
      }
      this.$http
        .getApp(url, { uid: this.uid })
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.list = res.data
          } else {
            this.$toast(res.msg)
          }
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.end-camp-list {
  width: 100vw;
  min-height: 100vh;
  position: relative;
  background: #f9f9f9;
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .sl-item {
    position: relative;
    width: 335px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 8px;
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    .i-left {
      flex: 1;
      .l-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.8);
        line-height: 22px;
        margin-bottom: 6px;
      }
      .l-date {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
        margin-bottom: 6px;
      }
      .c-name {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
      }
    }
    .i-btn {
      width: 64px;
      height: 25px;
      box-sizing: border-box;
      margin-left: 10px;
      background: rgba(98, 54, 255, 0.1);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: 400;
      color: #6236ff;
    }
    .i-flag {
      position: absolute;
      right: 0;
      top: 0;
      .flag-1 {
        padding: 0px 10px;
        background: #ad96ff;
        border-radius: 0px 8px 0px 8px;
        font-size: 10px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 18px;
      }
      .flag-2 {
        width: 45px;
        height: 37px;
        object-fit: contain;
      }
    }
  }
}
.c-btn {
  position: fixed;
  @include fixedBottom();
  left: 50%;
  transform: translateX(-50%);
  width: 335px;
  background: #6236ff;
  border-radius: 12px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  .iconfont {
    margin-right: 10px;
  }
}
</style>
